

import React, { useEffect, useState } from "react";
import moment from "moment";
import AddEditProject from "./corporateMemberSegment/AddEditProject";

const ProjectInProgress = ({ setProjectsInprogress,
    projectDevelopmentTypes,
    projectsInprogress, onSave, deleteById, swalAlert }) => {
    const [projects, setProjects] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [editingProject, setEditingProject] = useState(null);
    const initialProjectState = {
        corporateMemberProjectId: 0,
        developerLicenseNo: "",
        projectName: "",
        projectLocation: "",
        dateOfTOP: "",
        developmentTypeID: "",
        isProjectCompleted: false,
    };
    const [newProject, setNewProject] = useState(initialProjectState);

    useEffect(() => {
        if (projects !== projectsInprogress) {
            setProjectsInprogress(projects);
        }
    }, [projects]);


    useEffect(() => {
        if (projectsInprogress.length > 0) {
            setProjects(projectsInprogress);
        }
    }, [projectsInprogress]);

    const closeModal = () => {
        setIsOpen(false);
        setEditingProject(null);
        setNewProject(initialProjectState);
    };

    const handleEditClick = (id) => {
        const projectToEdit = projects.find((project) => project.id === id);
        if (projectToEdit) {
            setEditingProject({ ...projectToEdit });
            setIsOpen(true);
        }
    };

    const handleChange = (field, value) => {
        if (editingProject) {
            setEditingProject((prev) => ({ ...prev, [field]: value }));
        } else {
            setNewProject((prev) => ({ ...prev, [field]: value }));
        }
    };

    const handleSave = (id) => {
        const projectName = editingProject ? editingProject.projectName : newProject.projectName;

        if (!projectName?.trim()) {
            swalAlert.Alert("The Project Name field is required. Please fill it out before proceeding.");
            return;
        }

        let updatedProjects;
        let savedProject;

        if (editingProject) {
            updatedProjects = projects.map((project) =>
                project.id === editingProject.id ? editingProject : project
            );
            savedProject = editingProject;
        } else {
            const newId = projects.length ? Math.max(...projects.map((p) => p.id)) + 1 : 1;
            savedProject = { ...newProject, id: newId };
            updatedProjects = [...projects, savedProject];
        }

        setProjects(updatedProjects);
        setProjectsInprogress(updatedProjects);

        if (savedProject) {
            onSave(savedProject);
        }

        closeModal();
    };

    const setFilterParameters = (id, drpIdentity) => {
        if (drpIdentity === "ProjectDevelopmentTypes") {
            handleChange("developmentTypeID", id === 0 ? 0 : id);
        }
    };

    const handleDelete = (id) => {
        let project = projects.find((project) => project.id === id);

        let req = {
            id: project.corporateMemberProjectId,
            deletedBy: 115,
            appId: 112
        };

        deleteById(req);
        setProjects((prevProjects) =>
            prevProjects.filter((project) => project.id !== id)
        );
    };
    return (
        <div className="board-of-directors">
            <div className="add-btn-sec">
                <button type="button" className="btn btn-theme mb-4 txt underline flex"
                    onClick={() => {
                        setEditingProject(null);
                        setIsOpen(true);
                    }}
                >
                    + Add
                </button>
            </div>
            <div>
                <table className="bborder border-[#11378a] w-full">
                    <thead>
                        <tr className="bg-[#11378a] border text-white text-xl font-bold">
                            <th></th>
                            <th className="text-center py-2 px-5">Developer License No.</th>
                            <th className="text-center py-2 px-5">Project Name</th>
                            <th className="text-center py-2 px-5">Location</th>
                            <th className="text-center py-2 px-5">Expected Date Of Launch</th>
                            <th className="text-center py-2 px-5">Type of Development</th>
                            <th className="text-center py-2 px-5">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {projects.map((project, index) => (
                            <tr key={project.id}>
                                <td className="text-center py-2 px-2">{index + 1}.</td>
                                <td className="text-center py-2 px-2">{project.developerLicenseNo}</td>
                                <td className="text-center py-2 px-2">{project.projectName}</td>
                                <td className="text-center py-2 px-2">{project.projectLocation}</td>
                                <td className="text-center py-2 px-2">
                                    {project.expectedLaunchDate ? moment(project.expectedLaunchDate).format("DD MMM YYYY") : "-"}

                                </td>
                                <td className="text-center py-2 px-2">
                                    {projectDevelopmentTypes.find(
                                        (type) => type.id === project.developmentTypeID
                                    )?.name || "N/A"}
                                </td>


                                <td className="text-center py-2 px-2">
                                    <td className="text-center py-2 px-2">
                                        <button className="action-btn-edit mr-4" onClick={() => handleEditClick(project.id)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                                <path fill="currentColor" d="M20.094.25a2.25 2.25 0 0 0-1.625.656l-1 1.031l6.593 6.625l1-1.03a2.32 2.32 0 0 0 0-3.282L21.75.937A2.36 2.36 0 0 0 20.094.25m-3.75 2.594l-1.563 1.5l6.875 6.875L23.25 9.75zM13.78 5.438L2.97 16.155a.98.98 0 0 0-.5.625L.156 24.625a.975.975 0 0 0 1.219 1.219l7.844-2.313a.98.98 0 0 0 .781-.656l10.656-10.563l-1.468-1.468L8.25 21.813l-4.406 1.28l-.938-.937l1.344-4.593L15.094 6.75zm2.375 2.406l-10.968 11l1.593.343l.219 1.47l11-10.97z" />
                                            </svg>
                                        </button>
                                        <button className="action-btn-delete mr-4" onClick={() => handleDelete(project.id)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                                                <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                            </svg>
                                        </button>
                                    </td>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="add-edite-project-popup">
                    <AddEditProject
                        addEditModel={isOpen}
                        setOpenModal={setIsOpen}
                        editingProject={editingProject}
                        isProjectCompleted={projectsInprogress.isProjectCompleted}
                        newProject={newProject}
                        handleChange={handleChange}
                        handleSave={handleSave}
                        closeModal={closeModal}
                        setFilterParameters={setFilterParameters}
                        projectDevelopmentTypes={projectDevelopmentTypes}
                        validState={{ error: {} }}
                    />
                </div>
            </div>
        </div>
    );
}

export default ProjectInProgress;
